<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">SALES ORDERS</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formSalesOrderActive=!formSalesOrderActive"
							v-if="['master_admin','admin','finance'].includes(role) && role !== 'root'">{{ dicts.add_form[dicts.lang] }}
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formSalesOrderActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">{{ dicts.tittle_form[dicts.lang] }}</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.client[dicts.lang] }} <span style="color:red;">*</span></label>
								<smart-search init url="/api/master/v2/seeker/klien" key-tag="client"
								              :label-tag="['first_name','customer_id']" :addon="{used:'no'}"
								              v-on:clear="(res)=>{clearData()}"
								              v-on:update="(data)=>smartSearchUpdatedVessel(data)"
								              :search-value="newsoclientlabel"
								              @update-direct="(label)=>newsoclientlabel=label">
								</smart-search>
								
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.so[dicts.lang] }} <span
									style="color:red;">*</span></label>
									<div class="input-group">
									<!-- Input untuk sequenceNumber -->
									<input
										type="text"
										class="form-control w-25 rounded"
										v-model="newSalesOrder.orderNumber"
										maxlength="6"
										style="background-color: #ffffff;"
										placeholder="000"
									/>
									<!-- Input readonly untuk orderNumber -->
									<input
										type="text"
										class="form-control w-75 rounded"
										:value="computedOrderNumber"
										readonly
										style="background-color: #f0f0f0;"
									/>
									</div>
								
							</div>
							
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								
								<label class="d-block">{{ dicts.date[dicts.lang] }} <span style="color:red;">*</span></label>
								<b-form-datepicker
									today-button
									reset-button
									close-button
									id="example-datepicker"
									:date-format-options="{ day: 'numeric', month: 'short', year: 'numeric' }"
									v-model="newSalesOrder.dateSale"
									class="mb-2"
								>
									{{ newSalesOrder.dateSale }}
								</b-form-datepicker>
							</div>
							
							<!--Pelanggan-->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.sales_name[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded" v-model="newSalesOrder.salesman"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.admin_name[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded" v-model="newSalesOrder.adminName"
								       readonly/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newSalesOrder.detail"/>
							</div>

							<div class="col-12 mt-2" v-for="(data,index) in selectedHardwareSetup.vessel"
							     v-bind:key="'newSO'+data">
								<div class="row m-2 border p-3 border-light shadow-sm rounded">
									<div class="col-12">
										<h4>Detail #{{ ((currentPage - 1) * perPage) + index + 1 }}</h4>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">{{ dicts.vessel[dicts.lang] }}</label>
										<input type="text" class="form-control w-100 rounded" v-model="data.name"
										       readonly/>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2"
									     v-if="data.hardware_setup.serial_number!=null">
										<label class="d-block">{{ dicts.no_sn[dicts.lang] }}</label>
										<input type="text" class="form-control w-100 rounded"
										       v-model="data.hardware_setup.serial_number.serial_number" readonly/>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2">
										<label class="d-block">ID transmitter</label>
										<input type="text" class="form-control w-100 rounded"
										       v-model="data.hardware_setup.id_transmitter" readonly/>
									</div>
									<div class="col-12 col-md-6 col-lg-4 mt-2" v-if="data.hardware_setup.jb!=null">
										<label class="d-block">{{ dicts.no_jb[dicts.lang] }}</label>
										<input type="text" class="form-control w-100 rounded"
										       v-model="data.hardware_setup.jb.serial_number" readonly/>
									</div>
								</div>
							</div>

							
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newSalesOrderSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Sales Order Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewSalesOrder">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Sales Order Baru.</p>
										</div>
										<div v-for="err in errorSalesOrderList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="savingNewSalesOrder">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewSalesOrder">{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<div class="search-container">
						<input 
							type="text"
							class="search-input"
							placeholder="search"
							v-model="searchTerm"
							@input="doSearch"
						/>
					</div>
					<datatable 
								:currentIdx="currentPage"
								:lang="dicts.lang"
								:datas="salesorders"
								:structure="salesorderTableStructure"
								:init="loadData"
								use-seeker
								:next-url="nextUrl"
								:show-search="false"
								:hide-pagination="true"
								seeker-url="/api/pemesanan/seeker/order"
								@refetch="(row) => { rowLimit = row; getOrders() }"
								:prev-url="prevUrl"
								@change-page="(isNext) => { changePage(isNext) }"
								@change-url="(url) => getOrders(url + (url.includes('?') ? '&' : '?') + 'limit=' + rowLimit)"
								>
								
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.so[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0" style="font-size:10pt">{{ obj.order_number }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.client[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{
												obj.client ? obj.client.customer_id : "-"
											}}</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.client[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{
												obj.client ? obj.client.first_name : "-"
											}}</b>
										</div>
									</li>
									<li class="mt-2">
											<div class="text-left mx-3 pt-0">
												<small class="my-0 py-0">Serial Number Antena:</small>
												<br><b class="py-0 mx-0" style="font-size:10pt">
													{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_serial_number : "-" }}
												</b>
											</div>
											<hr class="my-1">
										</li>

										<li class="mt-2">
											<div class="text-left mx-3 pt-0">
												<small class="my-0 py-0">Transmitter ID:</small>
												<br><b class="py-0 mx-0" style="font-size:10pt">
													{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_id_transmitter : "-" }}
												</b>
											</div>
											<hr class="my-1">
										</li>

										<li class="mt-2">
											<div class="text-left mx-3 pt-0">
												<small class="my-0 py-0">No JB:</small>
												<br><b class="py-0 mx-0" style="font-size:10pt">
													{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_jb_serial_number : "-" }}
												</b>
											</div>
											<hr class="my-1">
										</li>
									
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.vessel[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{{
													obj.metadata[obj.metadata.length - 1].vessel != null && 
													obj.metadata[obj.metadata.length - 1].vessel ? 
													obj.metadata[obj.metadata.length - 1].vessel.name : "-"
											}}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">{{ dicts.date_sale[dicts.lang] }}:</small>
											<br><b class="py-0 mx-0"
											       style="font-size:10pt">{ obj.date_sale | timeformat }}</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-detail-so class="btn btn-primary mb-1 mr-2"
											          v-on:click="selectedDetail=index">
												<b-icon icon="eye"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-edit-so class="btn btn-info mb-1 mr-2"
											          v-on:click="()=>{selectedIdforEdit=index;cache.editData=Object.assign(cache.editData,salesorders[index])}"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id,itemToDelete=obj"
											          class="btn btn-danger mb-1 mr-2"
											          v-if="['master_admin','admin'].includes(role)">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.order_number }}</td>
							<td v-if="!isMobile">{{ obj.client ? obj.client.customer_id : "-" }}</td>
							<td v-if="!isMobile">{{ obj.client ? obj.client.first_name : "-" }}</td>
							<td v-if="!isMobile">
								{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_serial_number : "-" }}
							</td>

							<td v-if="!isMobile">
								{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_id_transmitter : "-" }}
							</td>

							<td v-if="!isMobile">
								{{ obj.metadata && obj.metadata[0] ? obj.metadata[0].display_jb_serial_number : "-" }}
							</td>

							<td v-if="!isMobile">
								
								{{
									obj.metadata[obj.metadata.length - 1].vessel != null && obj.metadata[obj.metadata.length - 1].vessel ? obj.metadata[obj.metadata.length - 1].vessel.name : "-"
								}}
							</td>
							<td v-if="!isMobile">{{ obj.date_sale | timeformat }}</td>
							<td v-if="!isMobile">
								<b-dropdown text="Actions" variant="primary" class="mb-2">
									<!-- Opsi Cetak -->
									<b-dropdown-item
									v-b-modal.modal-print-so
									@click="() => { selectedIdforEdit = index; cache.editData = Object.assign(cache.editData, salesorders[index]) }"
									v-if="['master_admin', 'admin','finance'].includes(role)"
									>
									<b-icon icon="printer"></b-icon> Cetak
									</b-dropdown-item>

									<!-- Opsi Detail -->
									<b-dropdown-item
									v-b-modal.modal-detail-so
									@click="selectedDetail = index"
									>
									<b-icon icon="eye"></b-icon> Detail
									</b-dropdown-item>

									<!-- Opsi Edit -->
									<b-dropdown-item
									v-b-modal.modal-edit-so
									@click="() => { selectedIdforEdit = index; cache.editData = Object.assign(cache.editData, salesorders[index]) }"
									v-if="['master_admin', 'admin','finance'].includes(role)"
									>
									<b-icon icon="pencil-square"></b-icon> Edit
									</b-dropdown-item>

									<!-- Opsi Hapus -->
									<b-dropdown-item
									v-b-modal.modal-delete
									@click="() => { deleteId = obj.id; itemToDelete = obj }"
									v-if="['master_admin', 'admin'].includes(role)"
									>
									<b-icon icon="trash"></b-icon> Hapus
									</b-dropdown-item>
								</b-dropdown>
								</td>

						</template>
					</datatable>
					<div class="d-flex justify-content-between align-items-center mt-2 pagination-mobile">

						<div class="text-muted" style="font-size: 10pt;">
							Showing {{ totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1 }}
							to {{ (currentPage - 1) * perPage + (salesorders ? salesorders.length : 0) }}
							of {{ totalItems }} entries
						</div>

						<div>
							<b-button 
								class="mr-2"
								variant="outline-primary"
								size="sm"
								:disabled="!prevUrl || loadData"
								@click="changePage(false)"
							>
								<b-icon icon="chevron-left"></b-icon> Prev
							</b-button>

							<b-button 
								variant="outline-primary"
								size="sm"
								:disabled="!nextUrl || loadData"
								@click="changePage(true)"
							>
								Next <b-icon icon="chevron-right"></b-icon>
							</b-button>
						</div>

					</div>
				</div>
				

				<b-modal no-close-on-esc size="lg" content-class="m-0" id="modal-print-so" title="Print Surat Jalan"
				         scrollable no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&salesorders.length>0">
						<b-row class="pt-1" v-if="salesorders[selectedDetail]!=undefined">
							<b-col cols="12" class="mb-3">
								<h4>Detail Tittle:</h4>
								<ul v-if="salesorders.length>0">
									<li>{{ dicts.so[dicts.lang] }}: {{ salesorders[selectedDetail].order_number }}</li>
									<li>{{ dicts.client[dicts.lang] }}:
										{{ salesorders[selectedDetail].client.legal_name }}
									</li>

									<li>Address {{ dicts.client[dicts.lang] }}:
										<textarea v-model="salesorders[selectedDetail].client.address"></textarea>
									</li>
									<li>{{ dicts.date[dicts.lang] }}: {{ salesorders[selectedDetail].date_sale }}</li>
									<!-- <li>PPN: {{salesorders[selectedDetail].ppn}}</li> -->
									<li>{{ dicts.sales_name[dicts.lang] }}: {{ salesorders[selectedDetail].salesman }}
									</li>
									<li>{{ dicts.admin_name[dicts.lang] }}:
										{{ salesorders[selectedDetail].admin_name }}
									</li>
									<li>{{ dicts.notes[dicts.lang] }}:
										<textarea v-model="salesorders[selectedDetail].detail"></textarea>
									</li>
									<li>{{ dicts.idtransmitter[dicts.lang]}} : {{ salesorders[selectedDetail].idtransmiter_id }}</li>
								</ul>
								<h4>Sales Order Detail</h4>
								<table class="table w-100 shadow-sm rounded">
									<tr>
										<th>{{ dicts.vessel[dicts.lang] }}</th>
										<th>{{ dicts.no_sn[dicts.lang] }}</th>
										<th>{{ dicts.no_jb[dicts.lang] }}</th>
										<th>{{ dicts.id_transmitter[dicts.lang] }}</th>
										<th>Keterangan</th>
									</tr>
									<tr v-for="meta in salesorders[selectedDetail].metadata"
									    v-bind:key="'detailmeta'+meta.id">
										<td>{{ meta.vessel ? meta.vessel.name : "-" }}</td>
										<td>
											{{
												meta.hardware_setup && meta.hardware_setup.id_transmitter ? meta.hardware_setup.id_transmitter : "-"
											}}
										</td>
										<td>
											{{
												meta.hardware_setup && meta.hardware_setup.serial_number != null ? meta.hardware_setup.serial_number.serial_number : "-"
											}}
										</td>
										<td>
											{{
												meta.hardware_setup && meta.hardware_setup.jb != null ? meta.hardware_setup.jb.serial_number : "-"
											}}
										</td>
										
										<td><textarea v-model="meta.hardware_setup.Keterangan"></textarea></td>
									</tr>
								</table>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 m-0 p-0">
							<hr>
							<div style="display: flex;justify-content: space-between;align-items: center;">
								<form class="row" style="align-items: center;padding:0px 20px" target="_blank" method="post" :action="$baseUrl+'/api/surat_jalan/'+salesorders[selectedDetail].id">
									<label class="d-block" style="margin:unset">Tanggal</label>
									<div class="col-6 col-md-6 col-lg-6">
										<input type="date" name="date_sj" class="form-control w-100 rounded" value="" />
										<input type="hidden" v-model="salesorders[selectedDetail].client.address" name="address">
										<input type="hidden" v-model="salesorders[selectedDetail].detail" name="keterangan_all">
										<div v-for="meta in salesorders[selectedDetail].metadata">
											<input type="hidden" v-model="meta.hardware_setup.Keterangan" :name="'meta_id['+meta.id+']'">
										</div>
									</div>
									<button class="btn btn-primary">
										Print SJ
									</button>
								</form>
								<form class="row" style="align-items: center;padding:0px 20px" target="_blank" method="get" :action="$baseUrl+'/api/tanda_terima/'+salesorders[selectedDetail].id">
									<button class="btn btn-primary">
										Tanda Terima
									</button>
								</form>
								<b-button class="btn btn-secondary"
								          @click="(!deleteState)?$bvModal.hide('modal-print-so'):''">
									{{ dicts.close[dicts.lang] }}
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>

				<b-modal no-close-on-esc size="lg" content-class="m-0" id="modal-detail-so" title=""
				         scrollable no-close-on-backdrop @hide="detailModalClose">
					<b-container fluid v-if="!loadData&&salesorders.length>0">
						<b-row class="pt-1" v-if="salesorders[selectedDetail]!=undefined">
							<b-col cols="12" class="mb-3">
								
								<h4>Sales Order Detail</h4>
								<table class="table w-100 shadow-sm rounded">
									<tr>
										<th>{{ dicts.admin_name[dicts.lang] }}</th>
										<th>{{ dicts.sales_name[dicts.lang] }}</th>
										<th>{{ dicts.notes[dicts.lang] }}</th>

									</tr>
									<tr v-for="meta in salesorders[selectedDetail].metadata"
									    v-bind:key="'detailmeta'+meta.id">
										<td>{{ salesorders[selectedDetail].admin_name }}</td>
										<td>{{ salesorders[selectedDetail].salesman }}</td>
										<td>{{ salesorders[selectedDetail].notes }}</td>
									</tr>
								</table>
							</b-col>
							<b-col cols="12" class="my-3 text-right" v-if="deleteState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menghapus data, tunggu sebentar.</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="deleted">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil menghapus data klien.
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="deleteFail">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal menghapus data klien.
									</div>
								</div>
							</div>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary"
							          @click="(!deleteState)?$bvModal.hide('modal-detail-so'):''">
								{{ dicts.close[dicts.lang] }}
							</b-button>
						</div>
					</template>
				</b-modal>

				<b-modal id="modal-edit-so" title="Edit data" no-close-on-backdrop size="lg" @hide="editModalClose">
					<div class="row" v-if="salesorders[selectedIdforEdit]!=undefined">
						<div class="row p-3 mx-2 bg-white">
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.client[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="salesorders[selectedIdforEdit].client.legal_name" readonly/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.so[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="salesorders[selectedIdforEdit].order_number"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.date[dicts.lang] }}</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="example-datepicker-edit" v-model="salesorders[selectedIdforEdit].date_sale"
									class="mb-2">{{ salesorders[selectedIdforEdit].date_sale }}
								</b-form-datepicker>
							</div>
							<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							  <label class="d-block">PPN</label>
							  <smart-select name="ppn" usedefault :default-value="translatePPN(salesorders[selectedIdforEdit].ppn)" :options="ppnTypeOptions" v-on:update="(value)=>{salesorders[selectedIdforEdit].ppn=value}"></smart-select>
							</div> -->
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.sales_name[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="salesorders[selectedIdforEdit].salesman"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.admin_name[dicts.lang] }}</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="salesorders[selectedIdforEdit].admin_name" readonly/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">{{ dicts.notes[dicts.lang] }}</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="salesorders[selectedIdforEdit].detail"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Update Sales Order Baru.
									</div>
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal update detail.</p>
										</div>
										<div v-for="err in errorSalesOrderList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-so')">
									{{ dicts.close[dicts.lang] }}
								</b-button>
								<button class="btn btn-info float-right" type="button" v-on:click="updateSalesOrder">
									{{ dicts.submit[dicts.lang] }}
								</button>
							</div>
						</div>
					</template>
				</b-modal>
			</div>
		</div>
		<modal-delete url="/api/pemesanan/order/" @read="()=>{console.log('modal ready')}" @result="deleteResult"
		              :targetid="deleteId">
			{{ dicts.desc_delete[dicts.lang] }}:<br>
			<ul>
				<li>{{ dicts.so[dicts.lang] }}: {{ itemToDelete.order_number }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
import {EventBus} from "../../eventbus";
import * as axios from "axios";
import moment from "moment";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			base_ppn:10,
			role: "",
			currentPage: 1,
			perPage: 10,
			totalEntries: 0,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			newsoclientlabel: "",
			cache: {
				editData: {}
			},
			isMobile: false,
			deleted: false,
			deleteFail: false,
			deleteState: false,
			selectedType: "all",
			itemToDelete: {},
			selectedvessel: "",
			selectedclient: "",
			selectedHardwareSetup: {},
			selectedserialnumber: "",
			selectedjb: "",
			deleteId: 0,
			salesorders: [],
			searchTerm: "",
			loadData: true,
			jb: [],
			antena: [],
			all: [],
			savingNewSalesOrder: false,
			errorNewSalesOrder: false,
			errorSalesOrderList: [],
			existingClientResult: [],
			newSalesOrderSaved: false,
			selectedTab: 0,
			selectedDetail: 0,
			selectedIdforEdit: 0,
			selectedToDelete: 0,
			totalNewsalesorder: 0,
			errorUpdate: false,
			updating: false,
			updateSaved: false,
			newSalesOrder: {
				clientId: "",
				dateSale: this.getTodayDate(),
				ppn: "yes",
				detail: "",
				salesman: "",
				adminName: "",
				hardwareSetupId: [],
				vesselId: [],
				sequenceNumber: '', 
				orderNumber: '',
			},
			
			formSalesOrderActive: false,
			salesorderTableStructure: [
				//label: nama heading, key: nama object property
				{label: "NO", key: null},
				{
					label: {
						id: "SO NUMBER",
						en: "SO NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "CID",
						en: "CID"
					},
					key: null
				},
				{
					label: {
						id: "CUSTOMER NAME",
						en: "CUSTOMER NAME"
					},
					key: null
				},
				{
					label: {
						id: "SERIAL NUMBER",
						en: "SERIAL NUMBER"
					},
					key: null
				},
				{
					label: {
						id: "SPKP ID/IMO",
						en: "SPKP ID/IMO"
					},
					key: null
				},
				{
					label: {
						id: "NO JB",
						en: "NO JB"
					},
					key: null
				},
				{
					label: {
						id: "VASSEL NAME",
						en: "VESSEL NAME"
					},
					key: null
				},
				{
					label: {
						id: "DATE",
						en: "DATE"
					},
					key: null
				},
				{
					label: {
						id: "ACTION",
						en: "ACTION"
					},
					key: null
				}
			],
			dicts: {
				lang: "id",
				add_form: {
					id: "ADD NEW",
					en: "ADD NEW"
				},
				tittle_form: {
					id: "Form sales order",
					en: "New sales order form"
				},
				client: {
					id: "CUSTOMER NAME",
					en: "CUSTOMER NAME"
				},
				so: {
					id: "SO NUMBER",
					en: "SO NUMBER"
				},
				date: {
					id: "DATE",
					en: "DATE"
				},
				idtransmitter: {
					id: "SPKP ID/IMO",
					en: "SPKP ID/IMO"
				},
				sales_name: {
					id: "SALES NAME",
					en: "SALES NAME"
				},
				admin_name: {
					id: "USER",
					en: "USER"
				},
				notes: {
					id: "NOTES",
					en: "NOTES"
				},
				vessel: {
					id: "VASSEL NAME",
					en: "VASSEL NAME"
				},
				date_sale: {
					id: "SO DATE",
					en: "SO Date"
				},
				no_sn: {
					id: "SERIAL NUMBER",
					en: "SERIAL NUMBER"
				},
				no_jb: {
					id: "JB NUMBER",
					en: "JB NUMBER"
				},
				id_transmitter: {
					id: "SPKP ID/IMO",
					en: "SPKP ID/IMO"
				},
				submit: {
					id: "SUBMIT",
					en: "SUBMIT"
				},
				list_vessel: {
					id: "LIST VASSEL",
					en: "LIST VASSEL"
				},
				nothing: {
					id: "NOTHING",
					en: "NOTHING"
				},
				close: {
					id: "CLOSE",
					en: "CLOSE"
				},
				desc_delete: {
					id: "Are you sure you want to delete the data with the following details?",
					en: "You are sure you want to delete data with the following details"
				}
			},
			ppnTypeOptions: [
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			TypeOptions: [
				{label: "All", value: "all"},
				{label: "Antena", value: "antena"},
				{label: "JB", value: "jb"}
			]
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getOrders();
		this.newSalesOrder.adminName = localStorage.getItem("currentUser");
		this.dicts.lang = localStorage.getItem("lang");
		EventBus.$on("lang", () => {
			console.log("changing sales order lang");
			this.dicts.lang = localStorage.getItem("lang");
		});
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		
	},
	computed: {
    
		computedOrderNumber() {
			const orderNumber = this.newSalesOrder.orderNumber || "000"; 
			const today = new Date();
			const month = today.getMonth() + 1; 
			const year = today.getFullYear(); 
			const romanMonth = this.getRomanMonth(month); 
			const companyCode = "MSP"; 
			return `${orderNumber}/SO-${companyCode}/${romanMonth}/${year}`;
		},
		showingFrom() {
			if (this.salesorders.length === 0) return 0;
			return ((this.currentPage - 1) * this.perPage) + 1;
		},
		showingTo() {
			const to = this.currentPage * this.perPage;
			return to > this.totalEntries ? this.totalEntries : to;
		}
	},
	methods: {
        getSetPpn(){
          axios.get(this.$baseUrl + "/api/setting?key=ppn", {
            "headers": {
              "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
          }).then((result) => {
            console.log(result);
            this.base_ppn = result.data.value;
            console.log(this.base_ppn);
          }).catch((err) => {
            //check if token fail
          });
        },
		// changePage(isNext) {
		// 	var url = (isNext ? this.nextUrl : this.prevUrl);
		// 	let params = (new URL(url)).searchParams;
		// 	const myParams = params.get("page");
		// 	this.currentPage = myParams;
		// 	var newUrl = this.$baseUrl + "/api/pemesanan/order?limit=" + this.rowLimit + "&page=" + myParams;
		// 	this.getOrders(newUrl);
		// },
		changePage(isNext) {
			// Ambil URL target (next / prev)
			let url = isNext ? this.nextUrl : this.prevUrl;
			if (!url) return;

			// Gunakan URLSearchParams agar saat pindah halaman, 
			// parameter 'page', 'limit', dan 'search' yang lama tidak hilang atau rusak
			let urlObj = new URL(url);
			let params = urlObj.searchParams;
			const targetPage = params.get("page") || 1;
			
			this.currentPage = targetPage;

			// Susun ulang request URL baru dengan mempertahankan text pencarian saat ini
			var newUrl = this.$baseUrl + "/api/pemesanan/order?limit=" + this.rowLimit + "&page=" + targetPage + "&search=" + (this.searchTerm || "");
			
			this.getOrders(newUrl);
		},
		doSearch() {
			// Fungsi pemicu saat user mengetik di kotak pencarian
			this.currentPage = 1; // Reset kembali ke halaman 1 saat mengetik kata kunci baru
			this.getOrders();
		},
		editModalClose() {
			this.$set(this.salesorders, this.selectedIdforEdit, this.cache.editData);
			this.cache.editData = Object.assign(this.cache.editData, {});
		},
		translatePPN(ppn) {
			var label = "";
			switch (ppn) {
				case "yes":
					label = "Ya";
					break;
				case "no":
					label = "Tidak";
					break;
			}
			return label;
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getOrders();
			}
		},
		
		
		getOrders(url = (this.$baseUrl + "/api/pemesanan/order?limit=" + this.rowLimit + "&search=" + (this.searchTerm || ""))) {
				this.loadData = true;
				axios.get(url, {
				headers: {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
				}).then((result) => {
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.salesorders = result.data.data;
				this.totalEntries = result.data.total;
				this.loadData = false;
				}).catch((err) => {
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.loadData = false;
				});
			},

		doSearch() {
			// whenever the input changes, call getOrders
			this.getOrders();
		},
		saveNewSalesOrder() {
			
			this.newSalesOrder.orderNumber = this.computedOrderNumber;
			this.savingNewSalesOrder = true;
			this.errorNewSalesOrder = false;
			if (
				this.newSalesOrder.orderNumber != ""
			) {
				var hardwareSetupIds = [];
				var vesselIds = [];
				console.log(this.selectedHardwareSetup.vessel);
				for (var x = 0; x < this.selectedHardwareSetup.vessel.length; x++) {
					hardwareSetupIds.push(this.selectedHardwareSetup.vessel[x].hardware_setup.id);
					vesselIds.push(this.selectedHardwareSetup.vessel[x].id);
				}

				console.log(hardwareSetupIds);
				console.log(vesselIds);

				axios.post(
					this.$baseUrl + "/api/pemesanan/v2/order",
					{
						"order_number": this.newSalesOrder.orderNumber,
						"client_name": this.selectedHardwareSetup.legal_name,
						"client_id": this.selectedHardwareSetup.id,
						"date_sale": this.newSalesOrder.dateSale,
						"ppn": this.newSalesOrder.ppn,
						"detail": this.newSalesOrder.detail,
						"salesman": this.newSalesOrder.salesman,
						"admin_name": this.newSalesOrder.adminName,
						"vessel_id": vesselIds,
						"hardware_setup_id": hardwareSetupIds
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.clear();
					console.log(result);
					console.log("oke");
					this.savingNewSalesOrder = false;
					this.newSalesOrderSaved = true;
					this.getOrders();
					setTimeout(() => {
						this.formSalesOrderActive = false;
						this.newSalesOrderSaved = false;
					}, 1000);
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.clear();
					console.log("not oke");
					console.log(err);
					console.log(err.response);
					this.savingNewSalesOrder = false;
					this.errorNewSalesOrder = true;
				});
			} else {
				console.log("data invalid");
				this.errorNewSalesOrder = true;
			}
		},
		updateSalesOrder() {
			this.updating = true;
			this.errorUpdate = false;
			var dataToUpdate = {
				date_sale: this.salesorders[this.selectedIdforEdit].date_sale,
				ppn: this.salesorders[this.selectedIdforEdit].ppn,
				detail: this.salesorders[this.selectedIdforEdit].detail,
				salesman: this.salesorders[this.selectedIdforEdit].salesman
			};

			// if ini dipakai karena order_number strict unique
			if (this.cache.editData.order_number !== this.salesorders[this.selectedIdforEdit].order_number) {
				dataToUpdate.order_number = this.salesorders[this.selectedIdforEdit].order_number;
			}

			axios.put(
				this.$baseUrl + "/api/pemesanan/v2/order/" + this.salesorders[this.selectedIdforEdit].id,
				dataToUpdate,
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					this.cache.editData = this.salesorders[this.selectedIdforEdit];
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-so");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		updateTypeValue(newType, idx) {
			//console.log("index "+ idx)
			//console.log(this.newSalesOrder.type[idx])
			this.newSalesOrder.type[idx] = newType;
			this.jb[idx] = (newType == "jb" ? true : false);
			this.all[idx] = (newType == "all" ? true : false);
			this.antena[idx] = (newType == "antena" ? true : false);
			this.$forceUpdate();
		},
		newUsernameChange() {
			this.newSalesOrder.password = this.newSalesOrder.username.toUpperCase();
		},
		deleteItem(item) {
			//console.log('button delete untuk user id: '+item.id)
		},
		updateUserRoleValue(newValue) {
			this.newSalesOrder.role = newValue;
		},
		setNewClientId(newId) {
			this.newSalesOrder.clientId = newId;
			//console.log(this.newSalesOrder.clientId)
		},
		smartSearchUpdatedClient(data, index) {
			this.newSalesOrder.client_id[index] = data.id;
			//console.log(this.newSalesOrder.client_id[index])
		},
		smartSearchUpdatedVessel(data) {
			console.log(data);
			this.selectedHardwareSetup = data;
			// this.newSalesOrder.clientId=data.id
			// this.selectedclient=data.vessel.client.first_name
		},
		clearData() {
			//this.newSalesOrder.clientId='';
		},
		
		smartSearchAddSerialNumber(data, idx) {
			this.newSalesOrder.serialNumberId[idx] = data.serial_number.id;
			this.selectedserialnumber = data.serial_number.serial_number;
		},
		smartSearchAddJB(data, idx) {
			this.newSalesOrder.noJb[idx] = data.jb.id;
			this.selectedjb = data.jb.serial_number;
		},
		updateNewSoPPN(data) {
			this.newSalesOrder.ppn = data;
		},
		smartSearchAddIdTransmitter(data, idx) {
			console.log(data);
			this.newSalesOrder.idTransmitterId[idx] = data.id;
			console.log(this.newSalesOrder.idTransmitterId);
		},
		addNewSalesOrder() {
			//console.log(this.newPurchaseOrder.hardware)
			this.newSalesOrder.serialNumberId.push("");
			this.newSalesOrder.idTransmitterId.push(0);
			this.newSalesOrder.noJb.push(0);
			this.newSalesOrder.type.push("all");
			this.jb.push(false);
			this.antena.push(false);
			this.all.push(true);
			this.totalNewsalesorder++;
			
		},
		deleteNewSalesOrder(index) {
			console.clear();
			
			this.newSalesOrder.serialNumberId.splice(index, 1);
			this.newSalesOrder.idTransmitterId.splice(index, 1);
			this.newSalesOrder.noJb.splice(index, 1);
			this.newSalesOrder.type.splice(index, 1);
			this.jb.splice(index, 1);
			this.antena.splice(index, 1);
			this.all.splice(index, 1);
			this.totalNewsalesorder--;
			
		},
		constructName(string, number) {
			return string + number.toString();
		},
		moment: function (date) {
			return moment(date).format("MMMM Do YYYY");
		},
		deleteData() {
			this.deleteState = true;
			axios.delete(this.$baseUrl + "/api/pemesanan/order" + this.salesorders[this.selectedToDelete].id, {
				headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
			})
				.then((result) => {
					if (result.status == 200) {
						this.salesorders.splice(this.selectedToDelete, 1);
						this.deleted = true;
						setTimeout(() => {
							this.deleted = false;
						}, 1500);

					} else {
						this.deleteFail = true;
					}
					this.deleteState = false;
				}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.deleteState = false;
				this.deleteFail = true;
			});
		},
		deleteModalClose(mdl) {
			if (this.deleteState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-so");
			}
		},
		detailModalClose(mdl) {
			if (this.deleteState) {
				console.log("detail");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-detail-so");
			}
		},
		
		getRomanMonth(month) {
			const romanMonths = [
				"", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII",
			];
			return romanMonths[month];
		},
		// Format ke YYYY-MM-DD sesuai kebutuhan <b-form-datepicker>
		getTodayDate() {
			const today = new Date();
			return today.toISOString().split('T')[0]; 
		},
		
		

		getMeta(obj) {
			if (!obj.metadata || obj.metadata.length === 0) return null;

			// ambil metadata terbaru → kalau mau yg lama, ubah ke .length - 1
			return obj.metadata[0];
		},

		safe(obj, path) {
			const meta = this.getMeta(obj);
			if (!meta) return "-";

			return path.split(".").reduce((acc, key) => {
			return acc && acc[key] !== undefined && acc[key] !== null ? acc[key] : null;
			}, meta) || "-";
		},
		// helper untuk metadata → aman walau hardware_setup null
		safeMeta(obj, path, fallback = "-") {
			if (!obj.metadata || obj.metadata.length === 0) return fallback;
			const meta = obj.metadata[0]; // atau pilih metadata terakhir jika mau
			if (!meta) return fallback;

			return path.split('.').reduce((acc, key) => {
			// cek null / undefined di tiap level
			return acc && acc[key] !== undefined && acc[key] !== null ? acc[key] : null;
			}, meta) || fallback;
		}
	},
	mounted() {
		// Inisialisasi nomor SO saat komponen dimuat
		// this.updateOrderNumber();
		 this.getOrders();
	},
	
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

::v-deep .modal.show .modal-dialog {
	transform: translate(0px, 10%);
}

::v-deep .modal-dialog-scrollable .modal-content {
	max-height: calc(100vh - 10.5rem);
}

h4 {
	margin: 0px 0px 15px;
}

.modal .modal-content .modal-body {
	padding-top: 0px;
}
.search-container {
  position: relative; 
  width: 100%; 
  margin-top: 0px; 
  padding-left: 0;
  margin-left: 0%; 
}

.search-input {
  position: absolute;
  left: 80%; 
  top: 20px; 
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
  width: 20%; 
}

.search {
  display: none !important;
}
</style>

